import React, { Fragment } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
export const Wrapper = styled.button `
  border: none;
  height: 32px;
  padding: 0 16px;
  color: inherit;
  font-size: ${(props) => props.theme.fontSmall};
  white-space: nowrap;
  line-height: 32px;
  cursor: pointer;
  width: 100%;
  text-align: left;

  ${(props) => props.isSelected
    ? `background-color: ${props.theme.blue}; color: #fff;`
    : `background-color: #fff;`}

  &:hover {
    background-color: ${(props) => props.isSelected ? props.theme.blue : props.theme.lightBlue};
  }

  &.disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
  &:focus {
    outline: none;
  }
`;
export const LinkWrapper = styled.div `
  height: 32px;
  padding: 0 16px;
  color: inherit;
  font-size: ${(props) => props.theme.fontSmall};
  white-space: nowrap;
  line-height: 32px;
  cursor: pointer;

  ${(props) => props.isSelected && `background-color: ${props.theme.blue}; color: #fff;`}

  &:hover {
    background-color: ${(props) => props.isSelected ? props.theme.blue : props.theme.lightBlue};
  }

  &.disabled {
    opacity: 0.5;
    cursor: default;
    pointer-events: none;
  }
`;
export const LinkItem = styled(Link) `
  display: block;
  color: inherit;
  text-decoration: none;

  &:hover {
    color: inherit;
    text-decoration: none;
  }
`;
const DropdownMenuItem = ({ link, to, onClick, disabled, children, value, isSelected, className, id, }) => {
    const wrapperProps = {
        onClick,
        disabled,
        className: disabled ? `${className} disabled` : className,
        isSelected,
        value,
    };
    return (React.createElement(Fragment, null, link ? (React.createElement(LinkWrapper, Object.assign({ id: id }, wrapperProps),
        React.createElement(LinkItem, { to: to }, children))) : (React.createElement(Wrapper, Object.assign({ id: id }, wrapperProps), children))));
};
export default DropdownMenuItem;
